import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const SideNav = ({
  navItems, header, stepsSubNavPath, stepsSubNav,
}) => (
  <div className="side-nav">
    {header && <h2>{header}</h2>}
    {navItems.length > 0
      ? navItems.map((navItem) => {
          const navName = navItem.path.replace('/', '') || 'home';
          return (
            <NavLink
              isActive={(match, location) => {
                if (location.pathname === navItem.path) {
                  return true;
                }
                // Home page would have already matched if active, so return false.
                if (navItem.path === '/') {
                  return false;
                }
                return location.pathname.indexOf(navItem.path) === 0;
              }}
              to={navItem.path}
              key={`nav-${navName}`}
              className={`nav-${navName}`}
            >
              {navItem.text}
              {stepsSubNavPath === navItem.path && stepsSubNav}
            </NavLink>
          );
        })
      : null}
  </div>
);

SideNav.displayName = 'SideNav';

SideNav.defaultProps = {
  header: '',
  stepsSubNavPath: '',
  stepsSubNav: null,
};

SideNav.propTypes = {
  navItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    path: PropTypes.string,
  })).isRequired,
  header: PropTypes.string,
  stepsSubNavPath: PropTypes.string,
  stepsSubNav: PropTypes.node,
};

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/siteNav/SideNav.js